export default __webpack_public_path__ + "static/media/vistasansbook-020415006EmigreWebOnly.3ac6007c.woff";